const pageHeaderItem = document.querySelectorAll('#pageheader .navigation__tier-1>.navigation__item.navigation__item--with-mega-menu .navigation__link'),
    megaHeaderItem = document.querySelectorAll('#main-nav .navigation__tier-1.main-menu-mega>.navigation__item'),
    menuHeaderItem = document.querySelectorAll('#main-nav .navigation__tier-1.main-menu-menu>.navigation__item.navigation__item--with-mega-menu .navigation__link'),
    linkHeaderItem = document.querySelectorAll('.navigation__tier-1>.navigation__item .navigation__link');

function getHandle(el) {
    removeHandle();
    document.querySelector('html').style.overflow = 'hidden';
    let item_value = el.getAttribute('data-handle');

    menuHeaderItem.forEach((item_menu) => {
        if(item_menu.getAttribute('data-handle') == item_value) {
            item_menu.classList.add('active')
        }
    })
    
    megaHeaderItem.forEach((item) => {
        item.classList.remove('navigation__item--show-children');
        let child_item = item.children[0];
        if(child_item.getAttribute('data-handle') == item_value) {
            item.classList.add('navigation__item--show-children')
        }
    })
}

function closeHandle() {
    removeHandle();
    megaHeaderItem.forEach((item) => {
        item.classList.remove('navigation__item--show-children');
    })

    document.querySelector('html').style.overflow = 'auto';
}

function removeHandle() {
    linkHeaderItem.forEach((item) => {
        item.classList.remove('active')
    })
}

pageHeaderItem.forEach((item) => {
    item.addEventListener('click', () => {
        getHandle(item)
    })
})

menuHeaderItem.forEach((item) => {
    item.addEventListener('click', () => {
        if (item.classList.contains('active')) {
            document.querySelector('.navigation--overlay').click()

            megaHeaderItem.forEach((item) => {
                item.classList.remove('navigation__item--show-children');
            })
            document.querySelectorAll('.navigation__tier-1-container .navigation__item').forEach(item => item.classList.remove('navigation__menu--active'))
            document.querySelector('html').style.overflow = 'auto';
        } else {
            document.querySelectorAll('.navigation__tier-1-container .navigation__item').forEach(item => item.classList.remove('navigation__menu--active'))
            getHandle(item)
        }
    })
})
